import { Notify } from "quasar"

export default function () {
	// Displays an error banner on top of the page
	const notifyError = (error, ...errors) => {
		let allErrors = [error, ...errors]
		console.error("notifyError:", ...allErrors)

		let errorStrings = []
		for (let error of allErrors) {
			let errorPrefix = ""
			let errorString = "Unknown error"
			if (!error) {
				// Fail fast if the error is not defined
				continue
			} else if (typeof error === 'string') {
				errorString = error
			} else if (error.response?.data?.message && error.response.data.message.length > 0) {
				// Handle API response errors
				errorPrefix = 'Response error: '
				errorString = error.response.data.message
			} else if (typeof Error.isError === 'function' && Error.isError(error)) {
				errorString = error.message
			} else if (error instanceof Error) {
				errorString = error.message
			} else if (typeof error === 'object' && error) {
				if (typeof error.response === 'object' && error.response) {
					errorPrefix = 'Request failed: '

					if (error.response.statusText) {
						errorString = error.response.statusText
					}

					if (typeof error.response.data === 'object' && error.response.data) {
						if (error.response.data.message) {
							errorString = error.response.data.message
						}
					} else if (typeof error.response.data === 'string' && error.response.data) {
						errorString = error.response.data
					}
				} else if (typeof error.request === 'object' && error.request) {
					errorPrefix = 'Request failed: '

					if (error.request.response) {
						errorString = error.request.response
					}
				} else if (typeof error.xhr === 'object' && error.xhr) {
					errorPrefix = 'Request failed: '

					if (error.xhr.statusText) {
						errorString = error.xhr.statusText
					}

					try {
						let response = JSON.parse(error.xhr.response)
						if (typeof response === 'object' && response.message) {
							errorString = response.message
						}
					} catch {
						// Do nothing.
					}
				}
			}
			errorStrings.push(errorPrefix + errorString)
		}

		// Don't display empty notification if all errors were falsy
		if (errorStrings.length === 0) {
			return
		}

		let message = errorStrings.join('')
		Notify.create({
			color: "negative",
			position: "top",
			message: message,
			icon: "tm:warning",
			actions: [
				{
					icon: 'tm:close',
					color: "white",
					handler: () => {
						/* ... */
					},
				},
			],
			// Display for 10 seconds
			timeout: 10000,
		})
	}

	// Display success banner on top of the page
	const notifySuccess = (message, timeout) => {
		Notify.create({
			color: "positive",
			textColor: "white",
			position: "top",
			message: message,
			icon: "tm:okay",
			actions: [
				{
					icon: 'tm:close',
					color: "white",
					handler: () => {
						/* ... */
					},
				},
			],
			timeout: timeout ?? 10000,
		})
	}

	// Display neutral banner on top of the page
	// The timeout is optional and defaults to 10 seconds
	const notifyInfo = (message, timeout) => {
		Notify.create({
			type: "info",
			color: "primary",
			position: "top",
			message: message,
			classes: 'glossy',
			actions: [
				{
					icon: 'tm:close',
					color: "white",
					handler: () => {
						/* ... */
					},
				},
			],
			// Display for 10 seconds by default
			timeout: timeout ?? 10000,
		})
	}

	// Display a warning banner on top of the page. Use for non-fatal
	// conditions that the user should notice (e.g. "your domain was added
	// but the optional Deep Dark Web scan was skipped because this segment
	// isn't licensed") - more prominent than notifyInfo, less alarming
	// than notifyError. Defaults to a longer 12s timeout because warnings
	// usually carry an explanation the user needs time to read.
	const notifyWarning = (message, timeout) => {
		Notify.create({
			color: "warning",
			textColor: "dark",
			position: "top",
			message: message,
			icon: "warning",
			actions: [
				{
					icon: 'tm:close',
					color: "dark",
					handler: () => {
						/* ... */
					},
				},
			],
			timeout: timeout ?? 12000,
		})
	}
	return {
		notifyError,
		notifyInfo,
		notifySuccess,
		notifyWarning,
	}
}
